<template>
   <g>
      <path
         d="M15 4.85596L7 12.856L15 20.856"
         stroke="currentColor"
         stroke-width="2"
         stroke-linecap="round"
         stroke-linejoin="round"
      />
   </g>
</template>

<script>
export default {
   data() {
      return {
         name: 'icon-chevron-left',
         viewBox: '0 0 24 25',
         fill: 'none',
      };
   },
};
</script>
